import { render, staticRenderFns } from "./ViewAttribute.vue?vue&type=template&id=a5d1f250&scoped=true&"
import script from "./ViewAttribute.vue?vue&type=script&lang=js&"
export * from "./ViewAttribute.vue?vue&type=script&lang=js&"
import style0 from "./ViewAttribute.vue?vue&type=style&index=0&id=a5d1f250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d1f250",
  null
  
)

export default component.exports